<span [ngClass]="[hasPosition() ? 'd-inline-block' : '', 'position-relative']">
    <div class="cap-notification-badge d-flex align-items-center justify-content-center position-absolute"
         *ngIf="showBadge"
         [ngStyle]="getBadgeStyles()">
        <span *ngIf="!icon && label" class="overflow-hidden">{{ label }}</span>

        <i *ngIf="icon" [ngClass]="icon"></i>

    </div>

    <ng-content *ngIf="hasPosition()"></ng-content>

</span>
